
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.429 1l-2.12 5.718a.609.609 0 00.044.504.5.5 0 00.168.175.426.426 0 00.221.065h2.63L4.486 15l8.094-8.766a.563.563 0 00.134-.274.61.61 0 00-.023-.312.533.533 0 00-.17-.245.432.432 0 00-.261-.095H8.727L10.612 1H5.429z","fill":"url(#paint0_linear_18209_60239)","stroke":"#FAE391","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_18209_60239","x1":"7.787","y1":"10.825","x2":"7.366","y2":"-10.665","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":".214","stop-color":"#CEA40A"}}),_c('stop',{attrs:{"offset":".214","stop-color":"#141F31","stop-opacity":"0"}})])])])
          )
        }
      }
    